import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M7.78092 12.5031H4.76292C4.43492 12.5031 4.16992 12.7691 4.16992 13.0961C4.16992 13.4231 4.43592 13.6901 4.76292 13.6901H7.78092C8.10892 13.6901 8.37392 13.4241 8.37392 13.0961C8.37392 12.7691 8.10792 12.5031 7.78092 12.5031Z"
      fill="currentColor"
    />
    <path
      d="M7.78092 14.54H4.76292C4.43492 14.54 4.16992 14.806 4.16992 15.134C4.16992 15.462 4.43592 15.728 4.76292 15.728H7.78092C8.10892 15.728 8.37392 15.462 8.37392 15.134C8.37392 14.806 8.10792 14.54 7.78092 14.54Z"
      fill="currentColor"
    />
    <path
      d="M19.661 5.95605H8.53298C7.96398 5.95605 7.41798 6.15805 6.96898 6.55205L2.68598 10.8351C2.67098 10.8501 2.65698 10.8661 2.64398 10.8821C2.24598 11.3011 2.00098 11.8691 2.00098 12.4911V15.7051C2.00098 16.9941 3.04998 18.0441 4.33898 18.0441H15.464C16.058 18.0441 16.602 17.8211 17.014 17.4551C17.03 17.4421 17.044 17.4291 17.059 17.4151L17.062 17.4111C17.099 17.3761 17.136 17.3401 17.17 17.3031L21.386 13.0841C21.782 12.6581 22.001 12.0981 22.001 11.5091V8.29405C22.001 7.00505 20.951 5.95605 19.661 5.95605V5.95605ZM16.613 15.7051C16.613 15.9991 16.503 16.2671 16.321 16.4711L16.229 16.5631C16.026 16.7451 15.757 16.8551 15.463 16.8551H4.33898C3.70498 16.8551 3.18798 16.3391 3.18798 15.7051V12.4911C3.18798 11.8571 3.70398 11.3401 4.33898 11.3401H15.464C16.098 11.3401 16.614 11.8561 16.614 12.4911V15.7041L16.613 15.7051ZM20.813 11.5091C20.813 11.7971 20.708 12.0691 20.531 12.2601L17.802 14.9911V12.4921C17.802 11.2021 16.752 10.1541 15.463 10.1541H5.04598L7.77798 7.42005C7.98198 7.24205 8.24998 7.14405 8.53198 7.14405H19.661C20.296 7.14405 20.812 7.66005 20.812 8.29405V11.5081L20.813 11.5091Z"
      fill="currentColor"
    />
    <path
      d="M14.976 12.5031H10.706C10.378 12.5031 10.113 12.7691 10.113 13.0961C10.113 13.4231 10.379 13.6901 10.706 13.6901H14.976C15.304 13.6901 15.57 13.4241 15.57 13.0961C15.569 12.7691 15.304 12.5031 14.976 12.5031Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Data');

export default Icon;
